"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const AutocompleteContext_1 = require("./AutocompleteContext");
const AutocompletePagination_1 = __importDefault(require("./AutocompletePagination"));
const AutocompleteSuggestionsWrap = styled_components_1.default.div.attrs({
    'data-id': `suggestions-container`,
})({ display: 'flex' }, ({ theme }) => theme.autocomplete.tagBlock, ({ theme: { media } }) => ({
    maxHeight: '100%',
    [media.tablet]: {
        maxHeight: '540px',
    },
}));
const SuggestionListBox = styled_components_1.default.ul.attrs({
    role: `listbox`,
})(({ theme }) => theme.autocomplete.suggestionListStyles);
function AutocompleteSuggestions(props) {
    var _a;
    const { children } = props, rest = __rest(props, ["children"]);
    const ctx = (0, AutocompleteContext_1.useAutocompleteContext)();
    const noPage = !ctx.page;
    const noSuggestions = ctx.suggestions.length === 0;
    const firstPageLoading = noPage && ctx.pageNumberExpected === 0 && ctx.loading;
    const hideSuggestions = firstPageLoading || noSuggestions || noPage;
    if (!ctx.loading && noSuggestions)
        return null;
    return (react_1.default.createElement(AutocompleteSuggestionsWrap, { className: "autocomplete-suggestions" },
        !hideSuggestions && (react_1.default.createElement(SuggestionListBox, Object.assign({}, rest), ctx.suggestions.map((item, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index }, children(item, ctx, index === ctx.selectedSuggestion)))))),
        ((_a = props === null || props === void 0 ? void 0 : props.suggestionsExtraButton) === null || _a === void 0 ? void 0 : _a.show) ? (react_1.default.createElement("div", { className: "autocompleteFooterWrap" },
            !ctx.loading ? props === null || props === void 0 ? void 0 : props.suggestionsExtraButton.button : null,
            react_1.default.createElement(AutocompletePagination_1.default, { withoutWrapper: props === null || props === void 0 ? void 0 : props.suggestionsExtraButton.show }))) : (react_1.default.createElement(AutocompletePagination_1.default, null))));
}
exports.default = AutocompleteSuggestions;
//# sourceMappingURL=AutocompleteSuggestions.js.map